// extracted by mini-css-extract-plugin
module.exports = {"v-scroll__wrapper":"VirtualScroll_v-scroll__wrapper__ImN2j","v-scroll__item":"VirtualScroll_v-scroll__item__VKhmM"};